import { AfterContentChecked, Component, Input } from '@angular/core';

export const translatePos = {x: 0, y: 0};

@Component({
  template: `<canvas
  (mouseover)="mouseover()"
  (mouseup)="mouseover()"
  (mousemove)="mousemove($event)"
  (mousedown)="mousedown($event)"
  id="canvas"></canvas>`,
  selector: 'viewer'
})
export class ImageViewerComponent implements AfterContentChecked {
  constructor(){}
  @Input('src') set src(s) {
    this.img.src = s
  };
  @Input('scale') scale: number = 1;
  private ctx: CanvasRenderingContext2D;
  private canvas: HTMLCanvasElement;

  private scaleMultiplier = 0.8;
  private startDragOffset:{x?: number, y?: number} = {};
  private mouseDown = false;
  private img = new Image();


  ngAfterContentChecked() {
    this.canvas =  <HTMLCanvasElement>document.getElementById("canvas");
    this.canvas.width = this.canvas.offsetWidth;
    this.canvas.height = this.canvas.offsetHeight;
    this.ctx = this.canvas.getContext("2d");

    this.draw();
  }


  mousedown(evt){
    this.mouseDown = true;
    this.startDragOffset.x = evt.clientX - translatePos.x;
    this.startDragOffset.y = evt.clientY - translatePos.y;
  };
  mouseup(){
    this.mouseDown = false;
  }
  mouseover(){
    this.mouseDown = false;
  }
  mouseout(){
      this.mouseDown = false;
  }
  mousemove(evt){
    if (this.mouseDown) {
      translatePos.x = evt.clientX - this.startDragOffset.x;
      translatePos.y = evt.clientY - this.startDragOffset.y;
      this.draw();
    }
  }

  draw(){
    // clear canvas
    const growFactor: number = this.canvas.width / this.img.width;
    if(this.scale < growFactor){
      this.scale = growFactor;
    }
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.save();
    this.ctx.scale(this.scale, this.scale);
    this.ctx.translate(translatePos.x/ this.scale, translatePos.y/ this.scale);
    this.ctx.drawImage(this.img, 0,0);

    this.ctx.restore();
  }
}
